// Cyclic procedure packages (dialysis etc.): an admission can have more than
// one, each with its own Cycle 1, 2, ... The backend tags every cycle
// Check-in/Check-out in biometricAuthLog with its package (itemCode, plus the
// PreAuth record as an audit reference) - see the API's
// helpers/cyclicBiometric.js packageCycleEntries, which these mirror.

export interface CyclePackageRef {
  itemCode: string
  preAuthId?: string
}

// Request fields for a cycle's package (insuranceLookup.service verify calls).
export function cyclePackageFields(cyclePackage?: CyclePackageRef): { itemCode?: string, preAuthId?: string } {
  return {
    ...(cyclePackage?.itemCode ? { itemCode: cyclePackage.itemCode } : {}),
    ...(cyclePackage?.preAuthId ? { preAuthId: cyclePackage.preAuthId } : {})
  }
}

// Whether a biometricAuthLog entry belongs to itemCode's cycles: entries
// tagged with that package, or untagged (older) entries when it is the
// admission's only cyclic package - with several, an untagged entry can't be
// attributed to any of them.
export function isPackageCycleEntry(entry: any, itemCode: string, cyclicItemCodes: string[]): boolean {
  if (entry?.itemCode) {
    return entry.itemCode === itemCode
  }
  const codes = new Set(cyclicItemCodes)
  return codes.size === 1 && codes.has(itemCode)
}

// A package's cycle entry of the given source ('cycle' = Check-in, 'checkout').
export function findPackageCycleEntry(log: any[], source: 'cycle' | 'checkout', itemCode: string, cycleNumber: number, cyclicItemCodes: string[]): any {
  return (log || []).find(l =>
    l?.source === source && Number(l?.cycleNumber) === cycleNumber && isPackageCycleEntry(l, itemCode, cyclicItemCodes)
  )
}
